import { Either, left, right } from "fp-ts/lib/Either";
import RestApi from "../../../settings/RestApi";

const restApi = new RestApi();

export const acceptTyCApiImpl = async (serviceId: string): Promise<Either<string, void>> => {
    try {
        await restApi.get(`/qrcodes/accept-terms/${serviceId}`);
        return right(undefined);
    } catch (error) {
        return left(error instanceof Error ? error.message : 'Error al aceptar términos y condiciones');
    }
};
